App.namespace('components.meta_templates', () => {
  const fillVariables = App.es6.shared.fill_variables;

  const $title = $('title');
  const $description = $('meta[name="description"]');

  const template = {
    title: $title.data('template'),
    description: $description.data('template'),
  };

  const update = (vars) => {
    $title.text(fillVariables(template.title, vars));
    $description.text(fillVariables(template.description, vars));
  };

  return {
    update,
  };
});
